<template>
  <Modal
    :value="visible"
    @on-ok="handleVisibleChange"
    @on-cancel="handleVisibleChange"
    class-name="choice-modal"
    width="745"
    title="更多课程概览"
  >
    <div class="table">
      <Table stripe :columns="tableColumns" :data="tableData"></Table>
    </div>
    <!-- <div class="paging">
      <Page
        :total="total"
        show-total
        show-elevator
        :current="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        @on-change="handlePageChange"
      />
    </div> -->
    <div slot="footer"></div>
  </Modal>
</template>

<script>
export default {
  name: "tableModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableColumns: {
      type: Array,
      default: () => []
    }
    // tableHttp: {
    //   type: String,
    //   default: ""
    // },
    // tableParams: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  data() {
    return {
      total: 0,
      pageInfo: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  methods: {
    // async getList() {
    //   const res = await this.tableHttp(this.tableParams);
    //   if (res.status === 200) {
    //     const { list, total } = res.message;
    //     this.total = !isNaN(+total) ? +total : 0;
    //     this.tableData = list;
    //   }
    // },
    // handlePageChange(num) {
    //   this.pageInfo.pageNum = num;
    //   this.getList();
    // },
    handleVisibleChange() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  height: 300px;
  max-height: 400px;
  overflow-y: auto;
  /deep/.ivu-table-header thead tr th {
    padding: 12px 0;
  }
  /deep/.ivu-table {
    th,
    td {
      border: 0;
    }
  }
}
</style>
